import { render, staticRenderFns } from "./FormDesignRender.vue?vue&type=template&id=1381084c&scoped=true"
import script from "./FormDesignRender.vue?vue&type=script&lang=js"
export * from "./FormDesignRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1381084c",
  null
  
)

export default component.exports